// extracted by mini-css-extract-plugin
export var blue = "#0eb3f2";
export var emphasis = "Scoreboard-module--emphasis--e6656";
export var green = "#57d33b";
export var greenLink = "Scoreboard-module--green-link--37996";
export var grey = "var(--tone-mid)";
export var header = "Scoreboard-module--header--01f36";
export var heading = "Scoreboard-module--heading--e6068";
export var icon = "Scoreboard-module--icon--e1e37";
export var notchGap = "32px";
export var orange = "#f8662b";
export var red = "#ff2741";
export var scoreboard = "Scoreboard-module--scoreboard--ad6ee";
export var titleIcon = "Scoreboard-module--titleIcon--b7705";
export var titleSection = "Scoreboard-module--titleSection--fd2b2";
export var widthDesktop = "1024px";
export var widthDesktopXl = "1280px";
export var widthExpanded = "1536px";
export var widthMobile = "640px";
export var widthTablet = "768px";
export var withScoreboard = "Scoreboard-module--withScoreboard--08576";
export var yellow = "#ffb100";